import { View } from 'react-native';
import Modal from "react-modal";

import { Oval } from "react-loader-spinner";


const loadingModalStyle = {
	content: {
		maxHeight: "100%",
		overflow: "hidden",
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		padding: 0,
		borderWidth: 0,
		backgroundColor: "transparent",
        zIndex: 50,
	},
    overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.15)"
	},
};

interface LoadingModalProps {
    isOpen: boolean;
}

function LoadingModal(props: LoadingModalProps){
    return (
        <Modal
            isOpen={props.isOpen}
            style={loadingModalStyle}
            contentLabel={"loading"}
            ariaHideApp={false}
		>
			<View style={{alignItems: "center", justifyContent:"center"}}>
				<Oval
					color={"#3261c2"}
					secondaryColor={"#fff"}
					height={60}
					width={60}
					strokeWidth={0}
					strokeWidthSecondary={3}
				/>
			</View>
		</Modal>
    )
}

export default LoadingModal;